/* eslint-disable react-refresh/only-export-components */
import "./GlobalTooltip.scss";

import { Tooltip } from "bootstrap";
import { ComponentOptions } from "bootstrap/js/dist/base-component";
import { FunctionComponent, useEffect } from "react";

import { createLogger } from "../../logging";

const logger = createLogger("GlobalTooltip");

const template =
  '<div class="tooltip global-tooltip" role="tooltip">' +
  '<div class="tooltip-shadow"></div>' +
  '<div class="tooltip-inner"></div>' +
  '<div class="tooltip-arrow"></div>' +
  "</div>";

const preventClose = false;
const showDelay = 5;
const hideDelay = preventClose ? 100000 : 10;

const tooltipOptions: ComponentOptions = {
  selector: ".global-tooltip-trigger",
  trigger: "hover focus",
  container: "body",
  customClass: "global-tooltip",
  html: true,
  template: template,
  placement: "top",
  delay: { show: showDelay, hide: hideDelay },
  title: getTitle,
};

export function showTooltips(selector = "global-tooltip-container") {
  const parent = document.getElementsByClassName(selector)[0];
  logger.trace("useEffect(): configure bootstrap tooltip", selector);

  try {
    Tooltip.getOrCreateInstance(parent, tooltipOptions);
  } catch {
    // ignore
  }
}
export function showTooltip(element: HTMLElement) {
  logger.trace(`showTooltip(): `, element);

  try {
    const widget = Tooltip.getInstance(element);
    widget?.show();
  } catch {
    // ignore
  }
}
export function hideTooltip(element: HTMLElement) {
  logger.trace(`hideTooltip(): `, element);

  try {
    if (preventClose) return;
    const widget = Tooltip.getInstance(element);
    widget?.hide();
  } catch {
    // ignore
  }
}

export function hideTooltips() {
  let elements = document.getElementsByClassName("global-tooltip");

  for (const i in elements) {
    try {
      const element = elements[i];
      element.parentElement?.removeChild(element);
    } catch (ex) {
      logger.trace(`Failed to remove tooltip`, ex);
    }
  }

  elements = document.getElementsByClassName("global-tooltip");
  if (elements.length) {
    logger.warn(`Still ${elements.length} active tooltips found after removal!`);
  }
}

function getTitle(...args: unknown[]) {
  //logger.trace(`getTitle(): `, args);
  hideTooltips();

  const el = args[0] as HTMLUnknownElement;
  let title = el.attributes.getNamedItem("title")?.value || el.attributes.getNamedItem("bs-title")?.value;
  if (!title) {
    const contentId = el.attributes.getNamedItem("data-for")?.value;
    if (contentId) {
      title = document.getElementById(contentId)?.innerHTML;
    }
  }

  logger.trace(`getTitle(): `, title);
  return title;
}

export const GlobalTooltip: FunctionComponent = () => {
  useEffect(() => {
    showTooltips();

    parent.addEventListener("mousedown", () => hideTooltips());
    parent.addEventListener("contextmenu", () => hideTooltips());

    return () => {
      logger.trace("useEffect(): cleanup");
      hideTooltips();
    };
  });

  return null;
};
